import React from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import Error500Page from "./Error500Page";
import Error403Page from "./Error403Page";
import Error404Page from "./Error404Page";

const ErrorsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route path="500" element={<Error500Page />} />
        <Route path="403" element={<Error403Page />} />
        <Route path="404" element={<Error404Page />} />
      </Route>
    </Routes>
  );
};

export default ErrorsPage;
